export default __webpack_public_path__ + "static/media/CoinGeckoLogo.dcede0f0.png";